import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authApi } from '../lib/domain';
import { ApiError } from '../lib/api';

export function RegisterPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (password.length < 6) {
      setError('Das Passwort muss mindestens 6 Zeichen lang sein.');
      return;
    }
    setBusy(true);
    try {
      await authApi.register(username.trim(), email, password);
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Registrierung fehlgeschlagen.');
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <div className="card stack">
        <h1>Fast geschafft</h1>
        <p>Wir haben dir eine Bestätigungs-E-Mail gesendet. Bitte bestätige deine Adresse, bevor du Gruppen oder die Community-Freigabe nutzt.</p>
        <p>
          Wie es danach weitergeht, erklärt die <Link to="/guide">Anleitung für die ersten Schritte</Link>.
        </p>
        <button className="primary" onClick={() => navigate('/login')}>
          Zur Anmeldung
        </button>
      </div>
    );
  }

  return (
    <div className="stack">
      <h1>Konto erstellen</h1>
      <form className="stack card" onSubmit={onSubmit}>
        <div className="field">
          <label htmlFor="username">Benutzername (3-32 Zeichen: A-Z, a-z, 0-9, - und _)</label>
          <input id="username" autoComplete="username" required minLength={3} maxLength={32} pattern="[A-Za-z0-9_\-]+" title="Nur Buchstaben (A-Z), Ziffern sowie - und _" value={username} onChange={(e) => setUsername(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="email">E-Mail-Adresse</label>
          <input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="password">Passwort (mind. 6 Zeichen)</label>
          <input id="password" type="password" autoComplete="new-password" minLength={6} required value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <p className="muted">
          Mit der Registrierung bestätigst du, die <Link to="/datenschutz">Datenschutzerklärung</Link> gelesen zu haben. Siehe auch das{' '}
          <Link to="/impressum">Impressum</Link>.
        </p>
        {error && <p className="error-text" role="alert">{error}</p>}
        <button className="primary" type="submit" disabled={busy}>
          Registrieren
        </button>
      </form>
      <p>
        Schon registriert? <Link to="/login">Anmelden</Link>
      </p>
    </div>
  );
}
